export default "__VITE_ASSET__ZkP$QIZS__"